import React from 'react';
import { Box, CardContent, Divider, LinearProgress, Typography } from '@mui/material';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { ContentViewType } from 'global';
import { CreditApplication } from '@trnsact/trnsact-shared-types';
import { useScorecard } from '../hooks/useScorecard';
import { ScoreSummarySection } from '../components/ScoreSummarySection';
import { ApplicantDataForm } from '../components/ApplicantDataForm';
interface Props {
  vo: any;
  refetchVO: any;
  vp: any;
  account: any;
  equipmentData: any;
  refetchEquipment: any;
  equipmentLoading: any;
  userProfile: any;
  refetchCreditApp: any;
  creditApplication: CreditApplication;
  portalConfigurationDataLoading: any;
  creditAppOwners: any[];
  cs: any;
  refetchCreditSubmission?: any;
  contentViewType?: ContentViewType;
}

export const ScoreCardV2 = ({
  vo,
  refetchVO,
  refetchCreditSubmission,
  vp,
  account,
  equipmentData,
  refetchEquipment,
  equipmentLoading,
  refetchCreditApp,
  cs,
  creditApplication,
  portalConfigurationDataLoading,
  contentViewType = ContentViewType.Desktop,
  creditAppOwners,
}: Props) => {
  const {
    scorecardCriteria,
    isLoading,
    totalScore,
    band,
    bandColor,
    breakDown,
    applicantData,
    listOfFacts,
    stringFactOptions,
    manualFields,
    setManualFields,
    handleSaveScoreCard,
  } = useScorecard(creditApplication, equipmentData, vo, cs, account, portalConfigurationDataLoading);

  const handleFieldChange = (key: string, value: any) => {
    setManualFields(f => ({ ...f, [key]: value }));
  };

  const handleSave = async () => {
    await handleSaveScoreCard(refetchCreditSubmission);
  };

  return scorecardCriteria ? (
    <CardContainer
      title="Scorecard"
      variant="elevation"
      contentViewType={contentViewType}
      actionBtnProps={
        !isLoading
          ? {
              label: 'Save',
              onClick: handleSave,
            }
          : undefined
      }
    >
      {!isLoading && (
        <Box sx={{ px: 2, pt: 2, pb: 1 }}>
          <Typography variant="caption" color="text.secondary">
            Scorecard results: {new Date().toLocaleDateString()}
          </Typography>
        </Box>
      )}
      <CardContent style={{ padding: 0 }}>
        {isLoading ? (
          <LinearProgress style={{ width: '100%' }} />
        ) : (
          <>
            <ScoreSummarySection totalScore={totalScore} band={band} bandColor={bandColor} breakDown={breakDown} />

            <Divider sx={{ mb: 3 }} />

            <ApplicantDataForm
              applicantData={applicantData}
              listOfFacts={listOfFacts}
              stringFactOptions={stringFactOptions}
              manualFields={manualFields}
              onFieldChange={handleFieldChange}
            />
          </>
        )}
      </CardContent>
    </CardContainer>
  ) : null;
};
